<template>
  <div>
    <div class="show-more"><span @click="handleSecond">{{ text.first.tips }}</span></div>
  </div>
</template>

<script>
import { home } from '@/js/text.js';
export default {
  name: 'ShowMore',
  data () {
    return {


    };
  },
  	computed: {
		text() {
			return this.$route.params.lang === 'CN' ? home.CN : home.EN
		}
	},
  mounted () {

  },
  methods: {
    handleSecond () {
      this.$emit('handleSecond')
    }

  }
};
</script>

<style scoped lang="scss">
.show-more {
  height: 90px;
  color: #fff;
  font-weight: bold;
  font-size: 12px;
  line-height: 16px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 0;
  z-index: 1;
  span {
    padding: 0 10px;
    cursor: pointer;
  }
  &::after {
    content: "";
    position: absolute;
    top: 28px;
    left: 50%;
    transform: translateX(-50%);
    height: 105px;
    width: 1px;
    background: #fff;
    animation: flex 1.3s linear infinite;
  }
}
@keyframes flex {
	0% {
		clip: rect(0px, 25px, 10px, -25px);
	}
	70% {
		clip: rect(0, 25px, 150px, -25px);
	}
	100% {
		clip: rect(0, 25px, 150px, -25px);
	}
}
</style>
